import classNames from "classnames";
import React from "react";
import PanelSegmentType from "./PanelSegment/PanelSegment";

export interface DetailViewPanelProps {
  className?: string
  title: string
  subTitle?: string
  articleId?: number
  headerChildren?: React.ReactNode
}

const DetailViewPanel = (props: React.PropsWithChildren<DetailViewPanelProps>) => {
  const classes = classNames("s1_panel", props.className);

  return (
    <div className={classes}>

      <PanelSegmentType>
        <PanelSegmentType.Header size="h2">
          <PanelSegmentType.Title title={props.title} subTitle={props.subTitle} />
          <PanelSegmentType.SupportQuestionMark articleId={props.articleId} />
          {props.headerChildren}
        </PanelSegmentType.Header>
      </PanelSegmentType>

      {props.children}
    </div>
  );
};

export default DetailViewPanel;